// src/utils.ts
function parseManifest(data) {
  const manifest = JSON.parse(data);
  if (!("animations" in manifest)) {
    throw new Error("Manifest not found");
  }
  if (manifest.animations.length === 0) {
    throw new Error("No animations listed in the manifest");
  }
  return manifest;
}
function isBytesZip(bytes) {
  const b = new Uint8Array(bytes, 0, 32);
  return b[0] === 80 && b[1] === 75 && b[2] === 3 && b[3] === 4;
}
async function fetchRequest(url, fetchOptions) {
  return await fetch(url, fetchOptions).then(
    (r) => r.arrayBuffer()
  );
}

// src/zip.ts
import { strFromU8, unzip } from "fflate";
async function base64fromU8(data) {
  const base64url = await new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(new Blob([data]));
    reader.onload = () => resolve(reader.result);
  });
  return base64url.split(",", 2)[1];
}
async function unZip(buffer) {
  const file = new Uint8Array(buffer);
  const lottieFile = await new Promise((resolve, reject) => {
    unzip(file, (err, unzipped) => err ? reject(err) : resolve(unzipped));
  });
  return {
    read: (path) => strFromU8(lottieFile[path]),
    readB64: async (path) => await base64fromU8(lottieFile[path])
  };
}

// src/fetch.ts
async function prepareLottieAssets(lottieJson, dotLottie) {
  if (!("assets" in lottieJson)) {
    return lottieJson;
  }
  async function parseAsset(asset) {
    if (!asset.p) {
      return asset;
    }
    if (dotLottie.read(`images/${asset.p}`) == null) {
      return asset;
    }
    const assetFileExtension = asset.p.split(".").pop() || "";
    const assetB64 = await dotLottie.readB64(`images/${asset.p}`);
    const isSvg = ["svg+xml", "svg"].includes(assetFileExtension);
    Object.assign(asset, {
      // TODO: image/png, image/jpeg ?
      p: `data:${isSvg ? "image/svg+xml" : ""};base64,${assetB64}`,
      e: 1
    });
    return asset;
  }
  const result = await Promise.all(
    lottieJson.assets.map((asset) => parseAsset(asset))
  );
  result.map((asset, i) => {
    lottieJson.assets[i] = asset;
  });
  return lottieJson;
}
async function unZipDotLottie(response) {
  const dotLottie = await unZip(response);
  const manifest = parseManifest(dotLottie.read("manifest.json"));
  const animations = await Promise.all(
    manifest.animations.map((a) => {
      const lottieJson = JSON.parse(
        dotLottie.read(`animations/${a.id}.json`)
      );
      return prepareLottieAssets(lottieJson, dotLottie);
    })
  );
  return {
    manifest,
    animations
  };
}
async function fetchLottie(url, fetchOptions) {
  const response = await fetchRequest(url, fetchOptions);
  if (isBytesZip(response)) {
    const { animations } = await unZipDotLottie(response);
    return animations[0];
  }
  return JSON.parse(new TextDecoder().decode(response));
}
export {
  fetchLottie
};
